import React from 'react';
import PropTypes from 'prop-types';
import { MaterialIcon } from '@pearsontechnology/aero-components';
import PlaceholderText from 'components/PlaceholderText';
import Link from 'data/Link';
import { Nav, P, RRLink } from './styles';
import { withTheme } from 'styled-components';
import { featureKeys } from 'services/FeatureFlagService';
import { compose } from 'redux';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';
import PublicationStatusCircle from './publicationStatusCircle';

export function genUniqIds(links) { // Exported for testing
  const uniqs = new Set();
  const ids = [];
  for (const link of links) {
    const { text, url } = link;
    let key = text || url;
    let used = uniqs.has(key);
    while (used) {
      key = `${key}1`;
      used = uniqs.has(key);
    }
    uniqs.add(key);
    ids.push(key);
  }
  return ids;
}

const Breadcrumbs = ({ links, theme, getFeatureFlagValue }) => {
  const ids = genUniqIds(links);
  const isGetActivityStatusEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_ACTIVITY_GET_ACTIVITY_STATUS);
  const extractActivityId = (url) => url.match(/\/course\/([^/]+)/)?.[1];

  return (
    <Nav>
      <P>
        {links.map((link, index) => {
          const last = index === links.length - 1;
          const INDEX_OF_COURSEWARE_NAME_IN_BREADCRUMB = 2;

          return (
            <React.Fragment key={ids[index]}>
              {!link.text && <PlaceholderText height={18} minWidth={60} maxWidth={100} />}
              {link.text && <RRLink last={last} to={link.url}>
                {link.text}
                {isGetActivityStatusEnabled && index === INDEX_OF_COURSEWARE_NAME_IN_BREADCRUMB && (
                  <PublicationStatusCircle
                    activityId={extractActivityId(link.url)}
                    theme={theme}
                  />
                )}
              </RRLink>}
              {!last && <MaterialIcon id="chevron_right" />}
            </React.Fragment>
          );
        })}
      </P>
    </Nav>
  );
};

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(PropTypes.instanceOf(Link)).isRequired,
  theme: PropTypes.object,
};
const flagNames = [
  featureKeys.WORKSPACE_ACTIVITY_GET_ACTIVITY_STATUS,
];
export default compose(
  withTheme,
  enhanceWithFeatureFlagSubscription,
)(Breadcrumbs, flagNames);

export { Breadcrumbs };
